import * as analytics from '../../api/analytics';
import { IOfferDetailPageOnSubmitParams } from '../../components/agentResaleOfferFlow/OfferDetailPage';
import { IAgent, IListing } from '../../declarations';
import * as actionTypes from './actionTypes';

export function errorListingOffer(listingOfferError: string) {
  return {
    payload: { listingOfferError },
    type: actionTypes.ERROR_LISTING_OFFER,
  };
}

export function getAgent(fullName: string, phone: string) {
  return {
    payload: { fullName, phone },
    type: actionTypes.GET_AGENT,
  };
}

export function setAgent(agent: IAgent) {
  return {
    payload: { agent },
    type: actionTypes.SET_AGENT,
  };
}

export function errorAgent(agentError: string) {
  return {
    payload: { agentError },
    type: actionTypes.ERROR_AGENT,
  };
}

export function getListing(listingSlug) {
  return {
    payload: { listingSlug },
    type: actionTypes.GET_LISTING,
  };
}

export function setListing(listing: IListing) {
  return {
    payload: { listing },
    type: actionTypes.SET_LISTING,
  };
}

export function errorListing(listingError: string) {
  return {
    payload: { listingError },
    type: actionTypes.ERROR_LISTING,
  };
}

export function setTypedAgentEmail(typedAgentEmail: string) {
  return {
    payload: { typedAgentEmail },
    type: actionTypes.SET_TYPED_AGENT_EMAIL,
  };
}

export function setTypedAgentFullName(typedAgentFullName: string) {
  return {
    payload: { typedAgentFullName },
    type: actionTypes.SET_TYPED_AGENT_FULL_NAME,
  };
}

export function setTypedAgentPhoneNumber(typedAgentPhoneNumber: string) {
  return {
    payload: { typedAgentPhoneNumber },
    type: actionTypes.SET_TYPED_AGENT_PHONE_NUMBER,
  };
}

export function submitListingOffer(offerDetails: IOfferDetailPageOnSubmitParams) {
  return {
    payload: { offerDetails },
    type: actionTypes.SUBMIT_LISTING_OFFER,
  };
}

export function setOfferSubmissionCompleted() {
  return {
    type: actionTypes.SET_OFFER_SUBMISSION_COMPLETED,
  };
}

export function setListingOffer(listingOffer) {
  return {
    payload: { listingOffer },
    type: actionTypes.SET_LISTING_OFFER,
  };
}

export function getDocumentUploadUrl(documentName: string, bucketName: string) {
  return {
    payload: {
      bucketName,
      documentName,
    },
    type: actionTypes.GET_DOCUMENT_UPLOAD_URL,
  };
}

export function errorOnGetDocumentUploadUrl(getDocumentUploadUrlError: string, s3Key: string) {
  return {
    payload: { s3Key },
    type: actionTypes.ERROR_ON_GET_DOCUMENT_UPLOAD_URL,
  };
}

export function uploadDocument(
  document: { file: File; s3Key: string },
  source,
  fileTypeId?: number | string,
) {
  return {
    payload: {
      document,
      fileTypeId,
      source,
    },
    type: actionTypes.UPLOAD_DOCUMENT,
  };
}

export function beginDocumentUpload(s3Key, source) {
  analytics.trackEvent('resale-offer-portal', 'upload', 'begin-upload', { s3Key });
  return {
    payload: {
      s3Key,
      source,
    },
    type: actionTypes.BEGIN_DOCUMENT_UPLOAD,
  };
}

export function documentUploadSuccess(s3Key, source, fileTypeId?: string | number) {
  analytics.trackEvent('resale-offer-portal', 'upload', 'upload-success', { s3Key });
  return {
    payload: {
      fileTypeId,
      s3Key,
      source,
    },
    type: actionTypes.DOCUMENT_UPLOAD_SUCCESS,
  };
}

export function errorOnDocumentUpload(s3Key: string, error: string, fileTypeId?: string | number) {
  return {
    payload: {
      error,
      fileTypeId,
      s3Key,
    },
    type: actionTypes.ERROR_ON_DOCUMENT_UPLOAD,
  };
}

export function deleteDocument(fileTypeId) {
  return {
    payload: { fileTypeId },
    type: actionTypes.DELETE_DOCUMENT,
  };
}
